import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import ListPageCardHeader from "components/Card/ListPageCardHeader";
import Loading from "components/Loading/Loading";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { reportsService } from "services/reportsService";
import { AgentTrackingFilter } from "./AgentTrackingFilter";
import { AgentTrackingMap } from "./AgentTrackingMap";

export const AgentTracking = () => {
    const { t } = useTranslation();
    const showToast = useCustomToast();
    const [trackingData, setTrackingData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async ({ filters }) => {
        try {
            setLoading(true);
            const response = await reportsService.getAgentsTracking(filters);
            const data = response?.data;
            setTrackingData(data);
        } catch (err) {
            showToast({ title: t(err), status: "error" });
        } finally {
            setLoading(false);
        }
    }, [showToast, t]);

    return (
        <Flex direction="column" gap="5" pt={{ base: "150px", lg: "90px" }}>
            <Flex
                w="100%"
                px="30px"
                justify="flex-end"
                align="center"
                gap="4"
                direction={{ sm: "column", md: "row" }}
            >
                <AgentTrackingFilter onFilter={(filters) => fetchData({ filters })} />
            </Flex>

            <Card>
                <ListPageCardHeader
                    title={t("reports.agent-tracking.title")}
                    subtitle={t("reports.agent-tracking.description")}
                />
                <CardBody>
                    {loading ? (
                        <Loading h="300px" w="100%" />
                    ) : (
                        <AgentTrackingMap data={trackingData} />
                    )}
                </CardBody>
            </Card>
        </Flex>
    );
};

export default AgentTracking;
